import { createAction, props } from '@ngrx/store';
import {
  ContextInterface,
  LearnerProfileConceptInterface,
  LearnerProfileStrandInterface,
  RecommendationInterface,
} from '../../+models';

export const loadRecommendationsForContext = createAction(
  '[Recommendations] Load Recommendations for Context',
  props<{
    context: ContextInterface;
    includeLearnerProfileConcepts?: boolean;
    includeLearnerProfileStrand?: boolean;
  }>()
);

export const recommendationsForContextLoaded = createAction(
  '[Recommendations] Recommendations for Context loaded',
  props<{
    context: ContextInterface;
    recommendations: RecommendationInterface[];
    learnerProfileConcepts?: LearnerProfileConceptInterface[];
    learnerProfileStrand?: LearnerProfileStrandInterface;
  }>()
);

export const recommendationsForContextLoadError = createAction('[Recommendations] Load Error', props<{ error: any }>());

export const exitBookDashboard = createAction('[BookDashboard] exit book dashboard');
